import { useDateNow, useReduxState } from 'hooks';
import { DisplayFormattedDate } from 'components/common';
import { Icon } from 'components/common/icons';
import { CardExtension } from 'components/common/tasks';

import { Path } from 'shared-types';

interface Props {
  courseIsCompleted: boolean;
  paths: (Pick<Path, 'id' | 'title'> & { deadline?: string })[];
}

const CoursesTilePaths = ({ courseIsCompleted, paths }: Props) => {
  const { dateNow } = useDateNow();

  const { messages, theme } = useReduxState();

  if (!paths?.length) return null;

  return (
    <div className="paths">
      {paths.map((path) => (
        <CardExtension href={`/paths/${path.id}`} icon="tasks" key={path.id}>
          <div
            className="path-title"
            aria-label={`${messages.commonPath}: ${path.title}`}
            data-tooltip={`${messages.commonPath}: ${path.title}`}
          >
            {path.title}
          </div>

          {path.deadline && !courseIsCompleted ? (
            <div
              className="path-deadline"
              aria-label={messages.courseTargetSchedule}
              data-tooltip={messages.courseTargetSchedule}
              style={{
                color:
                  Date.parse(path.deadline) < dateNow
                    ? theme.dangerColor
                    : theme.warningStandaloneColor
              }}
            >
              <Icon
                icon={['far', 'clock']}
                style={{ fontSize: '1.2rem', marginRight: 5 }}
              />

              <DisplayFormattedDate date={path.deadline} />
            </div>
          ) : null}
        </CardExtension>
      ))}

      <style jsx>{`
        .path-title {
          display: -webkit-box;
          flex-grow: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
        }
        .path-title:hover {
          text-decoration: underline;
        }
        .path-deadline {
          white-space: nowrap;
        }
      `}</style>
    </div>
  );
};

export default CoursesTilePaths;
